import { ZiggeoPlayerConfig } from './ziggeo-player-config';
import { ZiggeoPlayerComponent } from './ziggeo-player.component';

export { ZiggeoPlayerComponent, ZiggeoPlayerConfig };
